// extracted by mini-css-extract-plugin
export default {"submit":"q3RXAxtBxwQSRlXpnH2Q","root":"uVQRn47ypYfPuM_9aGqS","backButton":"f6PaM3U5nsAFegjcqxfR","text":"RANXzzT0vfDeIGNJBrIM","resend":"BPtr2bhN6EmHVF5tMujk"};